import { Module } from "wrapper6";
import ObjectFitClass from "../utils/_object-fit";

var $ = jQuery;

export default class LoadMore extends Module {

    ready() {
        if (document.querySelector('.mtt-articles-widget.archive')) {
            new LoadMoreClass({
                wrapper: document.querySelector('.mtt-articles-widget.archive'),
                action: 'loadmore_articles'
            });
        }
    }
}

class LoadMoreClass {

    constructor({ wrapper, action } = {}) {
        this.WRAPPER = wrapper;
        this.ACTION = action;
        this.LOADPREV_BUTTON = this.WRAPPER.querySelector('.load-prev-button');
        this.LOADMORE_BUTTON = this.WRAPPER.querySelector('.load-more-button');
        this.PROGRESS_COUNTERS = this.WRAPPER.querySelectorAll('.load-more__progress-count .counter');
        this.PROGRESS_INDICATORS = this.WRAPPER.querySelectorAll('.load-more__progress-indicator');
        this.TARGET = this.WRAPPER.querySelector('.mtt-articles-widget__wrap');
        
        this.url = this.WRAPPER.getAttribute('data-url');
        this.data = {
            'action': this.ACTION,
            'paged': this.TARGET.getAttribute('data-next-page')
        };

        if (this.LOADPREV_BUTTON) {
            this.LOADPREV_BUTTON.addEventListener('click', () => {
                if (!this.LOADPREV_BUTTON.classList.contains('disabled')) {
                    this.data.paged = parseInt(this.TARGET.getAttribute('data-prev-page')) - 1;
                    this.TARGET.setAttribute('data-prev-page', this.data.paged);
                    this.loadPrev();
                }
            });
        }

        if (this.LOADMORE_BUTTON) {
            this.LOADMORE_BUTTON.addEventListener('click', () => {
                if (!this.LOADMORE_BUTTON.classList.contains('disabled')) {
                    this.data.paged = parseInt(this.TARGET.getAttribute('data-next-page')) + 1;
                    this.TARGET.setAttribute('data-next-page', this.data.paged);
                    this.loadMore();
                }
            });
        }
    }

    loadMore() {
        this.setLoadingClass();
        $.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0) {
                this.TARGET && this.TARGET.insertAdjacentHTML('beforeend', response.markup);
                this.updateCount(response.pages, response.count);
                this.setUrl();
				new ObjectFitClass();
				this.removeLoadingClass();
            }
		});
    }

    loadPrev() {
        this.setLoadingClass();
        $.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0) {
                this.TARGET && this.TARGET.insertAdjacentHTML('afterbegin', response.markup);
                this.updateCount(response.pages, response.count);
                this.setUrl();
				new ObjectFitClass();
				this.removeLoadingClass();
            }
		});
    }

    updateCount(pages, count) {

        const POSTS = this.WRAPPER.querySelectorAll('.article-card');
        const POST_COUNT = POSTS.length;

        for (let i = 0; i < this.PROGRESS_COUNTERS.length; i++) {
            this.PROGRESS_COUNTERS[i].innerHTML = POST_COUNT;
        }

        for (let i = 0; i < this.PROGRESS_INDICATORS.length; i++) {
            this.PROGRESS_INDICATORS[i].style.width = (100 / count) * POST_COUNT + "%";
        }

        if (pages === this.data.paged && this.LOADMORE_BUTTON) {
            this.LOADMORE_BUTTON.innerHTML = this.LOADMORE_BUTTON.getAttribute('data-complete-text');
            this.LOADMORE_BUTTON.classList.add('disabled');
        }

        if (this.data.paged === 1 && this.LOADPREV_BUTTON) {
            this.LOADPREV_BUTTON.parentElement.classList.add('hide');
        }
    }

    setLoadingClass() {
        this.LOADPREV_BUTTON && this.LOADPREV_BUTTON.classList.add('loading');
        this.LOADMORE_BUTTON && this.LOADMORE_BUTTON.classList.add('loading');
    }

    removeLoadingClass() {
        this.LOADPREV_BUTTON && this.LOADPREV_BUTTON.classList.remove('loading');
        this.LOADMORE_BUTTON && this.LOADMORE_BUTTON.classList.remove('loading');
    }

    setUrl() {

        let parameters = '';
        
        // add pagenumber
		if (parseInt(this.data.paged) !== 1) {
			parameters += `?pagenumber=${this.data.paged}`;
        }

		if (parameters === '') {
			parameters = this.url;
		}

		window.history.pushState('articles', '', parameters);
	}
}